export const changeLocation = (newLocation: string): void => {
  window.location.assign(newLocation);
};
